// extracted by mini-css-extract-plugin
export default {"window":"orderHistory_window__mOuch","gray":"orderHistory_gray__ZSVWg","caption":"orderHistory_caption__vL-pq","status":"orderHistory_status__Fx3d+"};